<template>
    <div class="overf-steps" ref="scrollContainer">
        <div class="step-container">
            <div 
                :class="'step '+(step == 1 ? 'active':'')" 
                data-step="1" 
                :data-test="step"
                ref="step1"
            >
                <div class="step-number">01</div>
                <div class="head-title">
                    <h6>{{title1}}</h6>
                    <small>{{desc1}}</small>
                </div>
            </div>
            <div 
                :class="'step '+(step == 2 ? 'active':'')" 
                data-step="2"
                ref="step2"
            >
                <div class="step-number">02</div>
                <div class="head-title">
                    <h6>{{title2}}</h6>
                    <small>{{desc2}}</small>
                </div>
            </div>  
            <div 
                :class="'step '+(step == 3 ? 'active':'')" 
                data-step="3"
                ref="step3"
            >
                <div class="step-number">03</div>
                <div class="head-title">
                    <h6>{{title3}}</h6>
                    <small>{{desc3}}</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
name: 'Breadcrumbs',
props: ['title1','desc1','title2','desc2','title3','desc3','step', 'fo_content'],
data () {
    return {
        totalSteps: 3,
    }
},
computed: {
    currentStep(){
        return this.step;
    }
},
watch: {
    step(newStep) {
        setTimeout(() => {
            this.scrollToActiveStep(newStep);
        }, 100); // laisser le temps au DOM/CSS de se recalculer
    }
},
methods: {
    applyStyleVars() {
        Object.entries(this.fo_content).forEach(([key, value]) => {
            const cssVarName = `${key.replace(/_/g, '-')}`
            document.documentElement.style.setProperty(cssVarName, value)
            console.log(cssVarName);
        })
    },
    scrollToActiveStep(stepNumber) {
        this.$nextTick(() => {
            const scrollContainer = this.$refs.scrollContainer;
            if (!scrollContainer) return;

            const activeStep = this.$refs[`step${stepNumber}`];
            if (!activeStep) return;

            // Simple et fiable : position de l'étape dans le conteneur scrollable
            const scrollLeft = activeStep.offsetLeft 
                - (scrollContainer.offsetWidth / 2) 
                + (activeStep.offsetWidth / 2);

            scrollContainer.scrollLeft = Math.max(0, scrollLeft); // sans animation d'abord
            // puis avec animation
            scrollContainer.scrollTo({
                left: Math.max(0, scrollLeft),
                behavior: 'smooth'
            });
        });
    },
},
mounted() {
    this.applyStyleVars();
    
    this.$nextTick(() => {
        this.scrollToActiveStep(this.step);
    });
    
    this._resizeHandler = () => {
        this.$nextTick(() => {
            this.scrollToActiveStep(this.step);
        });
    };
    window.addEventListener('resize', this._resizeHandler);
},
beforeUnmount() {
    window.removeEventListener('resize', this._resizeHandler);
}
}

</script>

<style scoped>
.activeX{
font-display: inherit;
}
</style>